import React from 'react'
import { format } from 'date-fns'
import { Status } from '../../../components'
import { t } from 'i18next';

const columns = [
    {
        Header: t('name'),
        accessor: 'name'
    },
    {
        Header: t('code'),
        accessor: 'code',
    },
    {
        Header: t('type'),
        accessor: 'type',
    },
    {
        Header: t('createdAt'),
        accessor: 'createdAt',
        Cell: ({ value }: {value: any}) => {
            return format(new Date(value), 'dd MMM yyyy');
        }
    },
    {
        Header: t('doctors'),
        accessor: 'doctorsQty'
    },
    {
        Header: t('patients'),
        accessor: 'patientsQty'
    },
    {
        Header: t('status'),
        accessor: 'isActive',
        Cell: ({ value }: {value: any}) => <Status value={value ? t('active') : t('inactive')} color={value ? 'green' : 'red'} />
    }
];

export default columns;